import { DataGridPro } from "@mui/x-data-grid-pro";
import { Stack, Typography } from "@mui/material";
import { useMemo, useEffect } from "react";
import { useBoundStore } from "useStore";
import { tableStyles } from "./utils";
import AdsCheckboxHeader from "./Header/AdsCheckboxHeader";
import AdsCustomCheckbox from "./AdsCustomCheckbox";
import AdsActiveSwitch from "./AdsActiveSwitch";
import AdsDeleteButton from "./AdsDeleteButton";
import CpcCell from "./CpcCell";
import CvrCell from "./CvrCell";
import RoasCell from "./RoasCell";
import ContributionSalesHeader from "./Header/ContributionSalesHeader";
import ContributionSalesCell from "./ContributionSalesCell";
import AcosCell from "./Acos.Cell";
import VariantCell from "./VariantCell";
import StockCell from "./StockCell";
import ImpressionsCell from "./ImpressionsCell";
import CtrCell from "./CtrCell";
import ClicksCell from "./ClicksCell";
import TacosCell from "./TacosCell";
import RevenueCell from "./RevenueCell";
import CostCell from "./CostCell";
import ThumbnailField from "./ThumbnailField";


// function formatPercent(value) {
//   if (value == null) return "-";
//   return `${value.toFixed(2)}%`;
// }

const adsColumns = [
  {
    // ...GRID_CHECKBOX_SELECTION_COL_DEF,
    field: "checkbox",
    headerName: "Checkbox",
    renderHeader: () => <AdsCheckboxHeader />,
    renderCell: (params) => <AdsCustomCheckbox row={params.row} />,
    headerClassName: "header border-bottom",
    width: 62,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "active",
    headerName: "Activa",
    headerClassName: "header border-bottom",
    width: 70,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => <AdsActiveSwitch row={params.row} />,
  },
  {
    field: "pictureUrl",
    headerName: "Foto",
    headerClassName: "header border-bottom",
    renderCell: (params) => <ThumbnailField src={params.row.pictureUrl} />,
    minWidth: 80,
    flex: 0.8,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "title",
    headerName: "Producto",
    headerClassName: "header border-bottom",
    minWidth: 230,
    flex: 1.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "variants",
    headerName: "Variantes",
    headerClassName: "header border-bottom",
    renderCell: (params) => <VariantCell variants={params.row?.variants} />,
    minWidth: 80,
    flex: 0.8,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "availableQuantity",
    headerName: "Stock",
    headerClassName: "header border-bottom",
    renderCell: (params) => <StockCell stock={params.row?.availableQuantity} />,
    minWidth: 80,
    flex: 0.8,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "impressions",
    headerName: "Impresiones",
    headerClassName: "header border-bottom",
    minWidth: 100,
    flex: 0.8,
    resizable: false,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <ImpressionsCell impressions={params.row?.impressions} />
    ),
  },
  {
    field: "ctr",
    headerName: "CTR",
    headerClassName: "header border-bottom",
    renderCell: (params) => <CtrCell ctr={params.row?.ctr} />,
    minWidth: 90,
    flex: 1,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "clicks",
    headerName: "Clics",
    headerClassName: "header border-bottom",
    renderCell: (params) => <ClicksCell clicks={params.row?.clicks} />,
    minWidth: 90,
    flex: 1,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cpc",
    headerName: "CPC",
    headerClassName: "header border-bottom",
    minWidth: 80,
    renderCell: (params) => <CpcCell cpc={params.row?.cpc} />,
    flex: 0.8,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cvr",
    headerName: "CVR",
    headerClassName: "header border-bottom",
    renderCell: (params) => <CvrCell cvr={params.row?.cvr} />,
    minWidth: 80,
    flex: 0.8,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "roas",
    headerName: "ROAS",
    headerClassName: "header border-bottom",
    renderCell: (params) => <RoasCell roas={params.row?.roas} />,
    minWidth: 100,
    flex: 0.5,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "contributionSales",
    headerName: "Contribución de ventas",
    headerClassName: "header border-bottom",
    renderHeader: () => <ContributionSalesHeader />,
    renderCell: (params) => (
      <ContributionSalesCell
        ads={params.row?.salesContribution.adsPercentage}
        organic={params.row?.salesContribution.organicPercentage}
      />
    ),
    minWidth: 180,
    flex: 2,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "revenue",
    headerName: "Ingresos",
    headerClassName: "header border-bottom",
    minWidth: 120,
    renderCell: (params) => <RevenueCell revenue={params.row?.revenue} />,
    flex: 1,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cost",
    headerName: "Inversión",
    headerClassName: "header border-bottom",
    renderCell: (params) => <CostCell cost={params.row?.cost} />,
    minWidth: 120,
    flex: 1,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "acos",
    headerName: "ACOS",
    headerClassName: "header border-bottom",
    renderCell: (params) => <AcosCell acos={params.row?.acos} />,
    minWidth: 90,
    flex: 0.5,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "tacos",
    headerName: "TACOS",
    headerClassName: "header border-bottom",
    renderCell: (params) => <TacosCell tacos={params.row?.tacos} />,
    minWidth: 120,
    flex: 1,
    resizable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "actions",
    headerName: "Accion",
    headerClassName: "header border-bottom",
    renderCell: (params) => <AdsDeleteButton row={params.row} />,
    minWidth: 120,
    flex: 1,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "meliStatus",
    headerName: "MELI Status",
    headerClassName: "header border-bottom",
    minWidth: 120,
    flex: 1,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
];

export default function AdsTable({ data, rowCount }) {
  const selectedCampaign = useBoundStore((state) => state.selectedCampaign);
  const paginationModel = useBoundStore(
    (state) => state.adsTablePaginationModel,
  );
  const setPaginationModel = useBoundStore(
    (state) => state.setAdsTablePaginationModel,
  );
  const adsSelectionModel = useBoundStore((state) => state.adsSelectionModel);
  const setAdsSelectionModel = useBoundStore(
    (state) => state.setAdsSelectionModel,
  );
  const adsEditedRows = useBoundStore((state) => state.adsEditedRows);
  const toggleAdsEditedRow = useBoundStore((state) => state.toggleAdsEditedRow);
  const setAdsTableRows = useBoundStore((state) => state.setAdsTableRows);
  const selectedColumns = useBoundStore(
    (state) => state.campaignManagerColumnsAds,
  );

  const gridSx = useMemo(
    () => ({
      ...tableStyles,
      "& .MuiDataGrid-row.Mui-selected": {
        backgroundColor: "rgba(0, 40, 120, 0.08) !important",
      },
      "& .MuiDataGrid-row:hover": {
        backgroundColor: "rgba(0, 40, 120, 0.08) !important",
      },
      "& .MuiDataGrid-scrollbar": { pointerEvents: "auto" },
      "& .MuiDataGrid-scrollbar--horizontal": { outline: "none" },
      '& [tabindex="-1"]': { outline: "none !important" },
    }),
    [],
  );

  const rows = data ?? [];

  useEffect(() => {
    setAdsTableRows(rows);
  }, [rows, setAdsTableRows]);

  const handleRowSelectionModelChange = (newSelection) => {
    const removed = adsSelectionModel.filter((id) => !newSelection.includes(id));
    removed.forEach((id) => {
      if (adsEditedRows[id]) toggleAdsEditedRow(id, null);
    });
    setAdsSelectionModel(newSelection);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Stack direction="column" spacing={0.5}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#000000DE",
              fontSize: "24px",
              lineHeight: "24px",
            }}
          >
            {selectedCampaign?.campaignName}
          </Typography>
        </Stack>
        <Typography
          sx={{ fontSize: "14px", color: "#00000099", lineHeight: "24px" }}
        >
          {rows.length} anuncios
        </Typography>
      </Stack>

      <DataGridPro
        rows={rows}
        columns={adsColumns}
        getRowId={(row) => row.itemId}
        sx={gridSx}
        rowHeight={64}
        pagination
        paginationMode="server"
        rowCount={rowCount ?? rows.length}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[10, 25, 50]}
        columnVisibilityModel={selectedColumns}
        disableColumnMenu
        disableRowSelectionOnClick
        disableColumnReorder
        rowSelectionModel={adsSelectionModel}
        onRowSelectionModelChange={handleRowSelectionModelChange}
      />
    </Stack>
  );
}
